import AppUtils from '../../../util/util';
import {
     ENABLE_MAINTENANCE_BANNER,
     INITIAL_MAINTENANCE_CHECK_COMPLETED,
     SHOW_MAINTENANCE_BANNER,
     GET_DOWNTIME_DETAILS_SUCCESS,
     GET_DOWNTIME_DETAILS_ERROR,
     GET_DOWNTIME_DETAILS_INPROGRESS
} from '../../../constants/actions/adminSettings/maintenanceBanner/actionMaintenanceBanner';
import { HTTP_REQUEST_STATUS } from 'constants/constants';

const initialData = {
     enableBanner: false,
     initialCheckComplete: undefined,
     showBanner: true,
     downTimeStartDate: '',
     diffInhrs: 0,
     downTimeMessage: '',
     downTimeDetailsFetchStatus: HTTP_REQUEST_STATUS.NOT_STARTED
}

const ReducerMaintenanceBanner = (state = initialData, action) => {

     switch (action.type) {

          case INITIAL_MAINTENANCE_CHECK_COMPLETED: {
               return {
                    ...state,
                    initialCheckComplete: true
               }
          }

          case ENABLE_MAINTENANCE_BANNER: {
               return {
                    ...state,
                    enableBanner: action.data
               }
          }

          case SHOW_MAINTENANCE_BANNER: {
               return {
                    ...state,
                    showBanner: action.data
               }
          }

          case GET_DOWNTIME_DETAILS_INPROGRESS: {
               return {
                    ...state,
                    downTimeDetailsFetchStatus: HTTP_REQUEST_STATUS.IN_PROGRESS
               }
          }

          case GET_DOWNTIME_DETAILS_SUCCESS: {

               let downTimeStartDate = '';
               let diffInhrs = 0;
               let enableBanner = state.enableBanner;
               let downTimeMessage = '';

               /**If start and end date is present then enable the banner */
               if (typeof action.response !== 'undefined' &&
                    typeof action.response.data !== 'undefined') {

                    downTimeMessage = action.response.data.message || '';

                    const startDate = typeof action.response.data.start !== 'undefined' ?
                         new Date(action.response.data.start) :
                         undefined;

                    const endDate = typeof action.response.data.end !== 'undefined' ?
                         new Date(action.response.data.end) :
                         undefined;

                    if (startDate && endDate) {

                         /**calculate the hrs of downtime */
                         diffInhrs = AppUtils.differenceBtwTwoDatesInHrs(startDate, endDate);

                         const formattedDate = new Intl.DateTimeFormat('en-UK', {
                              day: '2-digit',
                              month: '2-digit',
                              hour: '2-digit',
                              minute: '2-digit',
                              timeZone: 'UTC'
                         }).format(startDate);
                         downTimeStartDate = formattedDate;

                         enableBanner = true;
                    }

                    /**Enable banner if message is present even without start/end dates */
                    if (downTimeMessage) {
                         enableBanner = true;
                    }
               }
               return {
                    ...state,
                    downTimeStartDate: downTimeStartDate,
                    diffInhrs: diffInhrs,
                    downTimeMessage: downTimeMessage,
                    enableBanner: enableBanner,
                    downTimeDetailsFetchStatus: HTTP_REQUEST_STATUS.SUCCESS
               }
          }

          case GET_DOWNTIME_DETAILS_ERROR: {
               return {
                    ...state,
                    downTimeStartDate: '',
                    downTimeMessage: '',
                    enableBanner: false,
                    downTimeDetailsFetchStatus: HTTP_REQUEST_STATUS.FAIL
               }
          }

          default:
               return state;
     }
};

export default ReducerMaintenanceBanner;